/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockMenuViewCtrl
 */
angular.module('mercury.modules.stock.menu')
.controller('StockMenuViewCtrl', ["dialog", "$q", "$resource", "$scope", "$state", "$stateParams", "SalesTax", "StockMenus", "title", "$window", "settings", function(dialog, $q, $resource, $scope, $state, $stateParams, SalesTax, StockMenus, title, $window, settings) {
  $scope.lineGroups = [];

  var PosItemLink = $resource(settings.apiHost + '/r/StockPositemLinks/:id', {id: '@id'});

  if (!$stateParams.id) {
    $state.go('Stock.Menu');
    return;
  }

  $scope.menu = StockMenus.get($stateParams.id);
  $scope.taxRates = SalesTax.getCompanySalesTaxAmounts();
  $scope.taxRates.then(function(result) {
    $scope.taxRates = result;
  });

  $scope.loading = $q.all([$scope.menu.$promise, $scope.taxRates]);
  $scope.loading.then(function() {
    title.set($scope.menu.name);

    angular.forEach($scope.menu.lines, function(line) {
      if (parseFloat(line.price) !== 0) {
        var salesTaxRate = SalesTax.getCompanySalesTaxRate($scope.taxRates, line.salesTaxRateId || 1);
        line.cogs = ((parseFloat(line.currentPrice) * parseFloat(line.stockUnitRatio)) / (parseFloat(line.price) / salesTaxRate)) * 100;
      } else {
        line.cogs = 0;
      }

      if (!line.stockItemId && !line.recipeId) {
        $scope.lineGroups.push({
          name: line.name,
          lines: []
        });
      } else {
        $scope.lineGroups[$scope.lineGroups.length - 1].lines.push(line);
      }
    });
  }, function() {
    $state.go('Stock.Menu');
  });

  /**
  * Print the current page.
  */
  $scope.print = function() {
    $window.print();
  };

  window.onafterprint = function() {
    $('.print-spinner', window.parent.document).removeClass('open');
    $('.print-embed', window.parent.document).remove();
  };

  $scope.newPrint = function(menu) {
    jQuery('.print-spinner').addClass('open');

    $('<iframe class="print-embed">')                             // create a new iframe element
    .css({'width': '1px', 'height': '1px', 'opacity': '0'})                            // make it invisible
    .attr('src', '/App/#/stock/menus/recipes/' + menu.id) // point the iframe to the page you want to print
    .appendTo('body');
  };

  $scope.posLinksDialog = function(line) {
    if (line.stockItemId) {
      $scope.posLinks = PosItemLink.query({stockItemId: line.stockItemId});
    } else {
      $scope.posLinks = PosItemLink.query({recipeId: line.recipeId});
    }

    $scope.linksStockItem = line.name;

    dialog.open({
      templateUrl: 'modules/stock/menu/positemlinks.tpl.html',
      scope: $scope
    });
  };
}]);
